import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import authService, { user$ } from '../../utils/services/authService';
import jobService from '../../utils/services/jobService';
import styles from './addJobThree.module.scss';

const AddJobThree = ({ jobPost, setJobPost, createdPostId, userData }) => {
  const [company, setCompany] = useState();
  //set to true when whole form is filled, controls navigate
  const [isFilled, setIsFilled] = useState(false);

  useEffect(() => {
    authService.getUserById(userData);

    user$.subscribe((data) => {
      if (data?.data.success) {
        setCompany(data.data.data[0]);
      }
    });
  }, []);

  useEffect(() => {
    console.log(company);
    if (company) {
      const { companyName, companySize, companyType, description, perks } =
        company;
      console.log(perks);
      setJobPost({
        ...jobPost,
        companyInfo: {
          companyName: companyName,
          companySize: companySize,
          companyType: companyType,
          companyDescription: description,
          perks: perks,
        },
      });
    }
  }, [company]);

  const formThreeClickHandle = (e) => {
    e.preventDefault();
    //set completed property to TRUE and send companyInfo
    const formData = {
      job: {
        companyInfo: { ...jobPost.companyInfo },
        completed: true,
      },
    };

    //Call API to update job
    const result = jobService.updateJob(createdPostId, formData).then((res) => {
      if (res.data?.success) {
        setIsFilled(true);
        console.log(res.data);
      }
    });
  };
  return (
    <section className={styles.companyInfo}>
      <h2 className={styles.companyInfo_heading}>Your info</h2>
      <h3 className={styles.companyInfo_subHeading}>About us</h3>
      <div className={styles.inner}>
        <h2 className={styles.inner_companyName}>{company?.companyName}</h2>
        <p className={styles.size}>
          Size:{' '}
          <span className={styles.size_value}>{company?.companySize}</span>
        </p>
        <p className={styles.type}>
          Type:{' '}
          <span className={styles.type_value}>{company?.companyType}</span>
        </p>
        <h3 className={styles.inner_descTitle}>Who we are</h3>
        <p className={styles.inner_description}>{company?.description}</p>
        <section className={styles.perks}>
          <h4 className={styles.perks_heading}>Benefits</h4>
          <div className={styles.perksInner}>
            {company?.perks.map((perk, index) => (
              <div key={index} className={styles.perkCard}>
                <h5 className={styles.perkCard_title}>{perk.perkTitle}</h5>
                <p className={styles.perkCard_body}>{perk.perkBody}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
      <button
        className={styles.btn}
        onClick={(e) => {
          formThreeClickHandle(e);
        }}
      >
        Continue
      </button>
      {isFilled === true ? (
        <Navigate to={`/profile/company/${userData.userId}`} />
      ) : (
        ''
      )}
    </section>
  );
};

export default AddJobThree;
